import styles from "./style.module.css";

const Loading = () => {
  return (
    <div>
      <div className={styles.loading} />
    </div>
  );
};

export default Loading;
